import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HeadToHeadFirebaseCollection, HeadToHeadID } from '@shared/types';
import { RootState } from 'types';

export type HeadToHeadSliceProps = {
  isLoading: boolean;
  isLoaded: boolean;
  headToHeadCollection: Record<HeadToHeadID, HeadToHeadFirebaseCollection>;
};

const initialState: HeadToHeadSliceProps = {
  isLoading: false,
  isLoaded: false,
  headToHeadCollection: {},
};

export const headToHeadSlice = createSlice({
  name: 'h2h',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
    setHeadToHeadCollection: (state, action: PayloadAction<Record<HeadToHeadID, HeadToHeadFirebaseCollection>>) => {
      state.headToHeadCollection = action.payload;
    },
    resetHeadToHeadCollection: () => {
      return { ...initialState };
    },
  },
});

export const { setIsLoading, setIsLoaded, setHeadToHeadCollection, resetHeadToHeadCollection } =
  headToHeadSlice.actions;

// #region UI Selectors *********************************************************
export const getIsLoading = (state: RootState): boolean => state.h2h.isLoading;
export const getIsLoaded = (state: RootState): boolean => state.h2h.isLoaded;
export const getHeadToHeadCollection = (state: RootState): Record<HeadToHeadID, HeadToHeadFirebaseCollection> =>
  state.h2h.headToHeadCollection;
// #endregion
export default headToHeadSlice.reducer;
